import type { ListStorageFileAuditOptions, StorageFileAuditEntry, StorageFileAuditListPage } from '@jarvis/platform-ui';
import { apiFetch, readJson } from './client';

export type { ListStorageFileAuditOptions, StorageFileAuditEntry, StorageFileAuditListPage };

function toQueryString(params: Record<string, string | number | boolean | undefined>): string {
  const parts = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
  return parts.length === 0 ? '' : `?${parts.join('&')}`;
}

export async function listStorageFileAudits(
  opts: ListStorageFileAuditOptions = {}
): Promise<StorageFileAuditListPage> {
  const res = await apiFetch(`/api/admin/storage-audit${toQueryString({ ...opts })}`);
  if (!res.ok) throw new Error(`Failed to list file audit events: ${res.status}`);
  return readJson<StorageFileAuditListPage>(res);
}
